import { useSubject } from '@aesop-fables/scrinium';
import { ToDoListData } from '../models/OffboardingData';
import { OffboardingTemplateSubject } from '../data/offboarding/subjects/OffboardingTemplateSubject';

export const useToDoList = () => {
  const todos = useSubject<ToDoListData[]>(OffboardingTemplateSubject);
  return todos;
};
